import { render, staticRenderFns } from "./NoticeBanner.vue?vue&type=template&id=37592ef6&scoped=true&"
import script from "./NoticeBanner.vue?vue&type=script&lang=js&"
export * from "./NoticeBanner.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBanner.vue?vue&type=style&index=0&id=37592ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37592ef6",
  null
  
)

export default component.exports